import { trackContentDownload } from './adobe';

export default function trackExtraFileDownload(pii, format, adobeContentType) {
  trackContentDownload(`er:sdf:pii:${pii}`, `er:sdf:${adobeContentType || 'article'}`, format);
}
